module.exports = PhotoSphereViewer.CubemapAdapter